import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, executeAwaitableHandlerChain, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import {
    GetProductCollectionApiV2Parameter,
    getProductCollectionV2,
} from "@insite/client-framework/Services/ProductServiceV2";
import { ProductCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";

type Parameter = (
    | GetProductCollectionApiV2Parameter
) &
    HasOnSuccess<ProductCollectionModel> &
    HasOnError<string>;

type Props = {
    apiParameter:
        | GetProductCollectionApiV2Parameter;
    apiResult: ProductCollectionModel;
};

type HandlerType = CustomApiHandler<Parameter, ProductCollectionModel>;

export const DispatchBeginLoadDesignerProducts: HandlerType = props => {
   props.dispatch({
    type:"Custom/DesignerProductList/BeginLoad",
   })
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const StoreAPIParameterData: HandlerType = props => {
    if (!props.parameter) {
        return;
    }
    props.dispatch({
        type: "Custom/DesignerProductList/CompleteLoadStore",
        searchparameter: props.apiParameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getProductCollectionV2(props.parameter) as any;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteLoadDesignerProducts: HandlerType = props => {
    // const state = props.getState() as unknown as CustomApplicationState;
    // const {
    //     pages: {
    //         productList: { isSearchPage },
    //     },
    // } = state;
    // const prevApiParams: typeof props.apiParameter = { ...props.apiParameter };
    // if(state.SURData.loadMoreDesignerProducts.loadMoreDesignerProducts){
    //     prevApiParams.page =
    //     props.apiParameter.page && props.apiParameter.page > 1
    //         ? props.apiParameter.page - 1
    //         : props.apiParameter.page;
    // }
    // let prevProducts = state.SURData.designerProductsStore.designerProducts;
    // if (props.apiResult.products && state.SURData.loadMoreDesignerProducts.loadMoreDesignerProducts) {
    //     props.apiResult.products = [...(prevProducts || []), ...props.apiResult.products];
    // } else {
    //     prevProducts = [];
    // }
    props.dispatch({
     type:"Custom/DesignerProductList/CompleteLoad",
     result: props.apiResult,
    })
 }; 

export const chain = [
    DispatchBeginLoadDesignerProducts,
    PopulateApiParameter,
    StoreAPIParameterData,
    RequestDataFromApi,
    DispatchCompleteLoadDesignerProducts,
];

const getDesignerProductsHandler = createHandlerChainRunner(chain, "GetDesignerProductsHandler");
export default getDesignerProductsHandler;
